/**
 * Fixes compatibility issues for SVGs on iOS devices.
 * Specifically handles the replacement of SVG `filter` attributes with CSS `filter: blur()`.
 * 
 * @param {SVGElement} svgElement - The root SVG element to process.
 */
export function fixIosSvgFilters(svgElement) {
    // Global iOS Fix for SVG Filters
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
        const filteredElements = svgElement.querySelectorAll('[filter]');
        for (let el of filteredElements) {
            // Check if it's a blur filter (often camo)
            const filterId = el.getAttribute('filter');
            if (filterId && (filterId.includes('blur') || filterId.includes('filter'))) {
                el.removeAttribute('filter');
                // Accumulate existing style
                const existingStyle = el.getAttribute('style') || '';
                // 2px is a reasonable default approximation
                el.setAttribute('style', `${existingStyle}; filter: blur(2px); -webkit-filter: blur(2px);`);
            }
        }
    }
}
